import $ from 'jquery';

export default function sortInit() {
  $('.sort-options').on('click', '.sort-options__toggle', ({currentTarget}) => {
    const $item = $(<HTMLElement> currentTarget.parentElement);
    $item.toggleClass('sort-options--open');
    $item.find('.sort-options__body').slideToggle(250);
  });
}